export const navGroups = [
  {
    title: "MARKETING",
    items: [
      {
        id: "greetings",
        label: "Contextual greetings",
        icon: "bi-chat-square-text"
      },
      {
        id: "ctas",
        label: "CTA configuration",
        icon: "bi-bullseye"
      },
      {
        id: "cta-action",
        label: "CTA action & link",
        icon: "bi-link-45deg"
      },
      {
        id: "page-rules",
        label: "Page rules",
        icon: "bi-file-earmark-check"
      },
      {
        id: "conversions",
        label: "Conversion tracking",
        icon: "bi-graph-up-arrow"
      }
    ]
  },

  {
    title: "TEAM & INTEGRATIONS",
    items: [
      {
        id: "team",
        label: "Team users",
        icon: "bi-people"
      },
      {
        id: "integrations",
        label: "Integrations",
        icon: "bi-plug"
      }
    ]
  }
];

export const greetings = [
  {
    id: 1,
    name: "Pricing page greeting",
    target: "/pricing",
    trigger: "Exit intent",
    cta: "Book a demo",
    priority: "High",
    status: true,
    message: "Hi there! 👋 How can we help you today?"
  },

  {
    id: 2,
    name: "Product welcome",
    target: "/product/*",
    trigger: "10 sec delay",
    cta: "Learn more",
    priority: "Medium",
    status: true,
    message: "Welcome! Need help choosing the right product?"
  },

  {
    id: 3,
    name: "Returning visitor",
    target: "All pages",
    trigger: "Returning visitor",
    cta: "Continue",
    priority: "Low",
    status: false,
    message: "Welcome back! 👋 Can we help with anything?"
  }
];

export const ctas = [
  {
    id: 1,
    name: "Book a demo",
    text: "Book a demo",
    type: "Primary",
    action: "Open URL",
    status: true
  },

  {
    id: 2,
    name: "Talk to sales",
    text: "Talk to sales",
    type: "Secondary",
    action: "Open URL",
    status: true
  },

  {
    id: 3,
    name: "Start free trial",
    text: "Start free trial",
    type: "Primary",
    action: "Open form",
    status: false
  }
];

export const pageRules = [
  {
    id: 1,
    name: "Pricing pages",
    condition: "URL contains /pricing",
    behavior: "Show greeting",
    priority: 1,
    status: true
  },

  {
    id: 2,
    name: "Documentation pages",
    condition: "URL starts with /docs",
    behavior: "Show CTA",
    priority: 2,
    status: true
  },

  {
    id: 3,
    name: "Checkout page",
    condition: "URL equals /checkout",
    behavior: "Hide widget",
    priority: 3,
    status: false
  }
];

export const conversions = [
  {
    id: 1,
    name: "Demo booked",
    event: "demo_booked",
    source: "CTA: Book a demo",
    goal: "Lead",
    status: true
  },

  {
    id: 2,
    name: "Trial started",
    event: "trial_started",
    source: "CTA: Start free trial",
    goal: "Signup",
    status: true
  },

  {
    id: 3,
    name: "Contact submitted",
    event: "contact_submitted",
    source: "Form",
    goal: "Lead",
    status: false
  }
];

export const users = [
  {
    id: 1,
    name: "Aarav Sharma",
    email: "aarav@chatbizz.com",
    role: "Owner",
    status: "Active",
    lastSeen: "Just now",
    initials: "AS"
  },

  {
    id: 2,
    name: "Priya Reddy",
    email: "priya@chatbizz.com",
    role: "Admin",
    status: "Active",
    lastSeen: "12 min ago",
    initials: "PR"
  },

  {
    id: 3,
    name: "Rahul Kumar",
    email: "rahul@chatbizz.com",
    role: "Editor",
    status: "Invited",
    lastSeen: "—",
    initials: "RK"
  },

  {
    id: 4,
    name: "Meera Nair",
    email: "meera@chatbizz.com",
    role: "Viewer",
    status: "Active",
    lastSeen: "Yesterday",
    initials: "MN"
  }
];